<template>
    <div class="form-info">
        <div class="form-row">
            <div class="form-label">
                <label>所属业务单元</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.bizUnitName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>所属部门</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.comName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>用户名称</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.userName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>范围名称</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.scopeName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>执行动作</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.action}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>IP地址</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.devIp}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>执行动作详细</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.actionDetail}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>设备平台</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.devPlat}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>平台系统名称</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.sysName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>操作系统名称</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.osName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>请求路径</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.reqUrl}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>附加信息</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.extras}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>创建时间</label>
            </div>
            <div class="form-value">
                <span>{{bizLogInfo.createTime}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-biz-log-info',
        desc: '服务商日志详情',
        props: ["id", "merchant"],
        data: function () {
            return {
                bizLogInfo: {},
            }
        },
        created: function () {
            let self = this;
            self.getBizLogInfo();
        },
        methods: {
            getBizLogInfo: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                servicerApi.getServcerBizLog(postData, function (result) {
                    if(result.type == "info") {
                        self.bizLogInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/bizLog/BizLogInfo.vue